import React, { PropsWithChildren } from 'react';

import {
  useGetActiveEvent,
  getGetActiveEventQueryOptions,
  getGetNextEventQueryOptions,
  useGetNextEvent,
} from '../api/agency-api';
import { ActiveEventContext, NextEventContext } from '../shared/events';
import { queryClient } from './QueryProvider';

queryClient.prefetchQuery(getGetNextEventQueryOptions());
queryClient.prefetchQuery(getGetActiveEventQueryOptions());

export const EventContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
  // refetch event 15 minutes
  const { data: next } = useGetNextEvent({ query: { refetchInterval: 15 * 60 * 1000 } });
  // refetch every 5 minutes
  const { data: active } = useGetActiveEvent({ query: { refetchInterval: 5 * 60 * 1000 } });

  return (
    <NextEventContext.Provider value={next?.event ?? null}>
      <ActiveEventContext.Provider value={active?.event ?? null}>
        {children}
      </ActiveEventContext.Provider>
    </NextEventContext.Provider>
  );
};
